<template>
  <div>
    <form class="form-container" @submit.prevent="register" v-if="!savedSuccessful">
      <br/>
      <br/>
      <input 
        placeholder="order no." 
        v-model="order_id"  
        type="text" 
        name="order_id"
        value 
      />
      <input 
        placeholder="custumer name" 
        v-model="firstName" 
        type="text" 
        name="firstName" 
        value />

      <input 
        placeholder="customer surname" 
        v-model="lastName" 
        type="text" 
        name="lastName" 
        value />

      <input 
        placeholder="email (* required)" 
        v-model="email"  
        :class="{ error: !$v.email.$error }" 
        type="email" 
        name="email"
        @blur="$v.email.$touch()" 
        value 
      />
      <template v-if="$v.email.$error">
        <div v-if="!$v.email.email" class="errorMessage">Please enter valid email address.</div>
        <div v-if="!$v.email.required" class="errorMessage">Email is required!</div>
      </template>

      <input 
        placeholder="short description (* required)" 
        v-model="comment"
        :class="{ error: !$v.comment.$error }" 
        type="comment" 
        name="comment" 
        @blur="$v.comment.$touch()" 
        value />
      <template v-if="$v.comment.$error">
        <div v-if="!$v.comment.required" class="errorMessage">Please provide a short description of the issue.</div>
      </template>

      <button class="add-btn" type="submit" name="button">
        Create ticket
      </button>

      <ul>
        <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
      </ul>
    </form>
    <template v-if="savedSuccessful"> 
      <div class="success">New ticket created succesfully!</div>
    </template>
  </div>
</template>

<script>

import { required, email } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      email: '',
      comment: '',
      firstName: '',
      lastName: '',
      order_id: '',
      errors: null,
      error: false,
      savedSuccessful: false
    }
  },
  validations: {
    email: {
      required,
      email,
    },
    comment: {
      required,
    },
  },
  methods: {
    register() {
      this.$store
        .dispatch('createClient', {
          email: this.email,
          password: this.password,
          firstName: this.firstName,
          lastName: this.lastName,
          role: this.role
        })
        .then(() => {
          this.savedSuccessful = true; // automatically shows success message if account has been created successfully"//
        })
        .catch(err => {
          this.errors = err.response.data.errors
        })
      this.$v.$touch();
      if (!this.$v.$invalid) {
        // console.log("form submitted:", this.email);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-container {
  //position: absolute;
  background: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0px 0px 8px 0px #000;
}

a:visited {
  color: #2c3e50;
}

.add-btn {
  background: var(--primary);
  color: var(--bright);
  padding: 0.3em;
  letter-spacing: 3px;
  width: 80%;
}

.button,
button {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background: linear-gradient(to right, $secondary, $secondary-dark);
  font-size: 1.5em;
  color: white;
  border: none;
  width: 80%;
  margin-top: 1em;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  outline: none;
}

form {
  display: flex;
  align-items: center;
  flex-direction: column;

  p {
    color: red;
  }
}

input {
  display: block;
  box-sizing: border-box;
  border-style: solid;
  width: 80%;
  height: 2.6em;
  padding: 0.5em;
  margin-top: 2.0em;
  font: 1em 'Lato', Helvetica, sans-serif;
}
h1 {
  margin-top: 0;
}
.success {
  font-size: 2.3em;
  color: green;
  margin: 3em;
}
.errorMessage {
  margin-top: 0.2em;
  color: var(--primaryDark);
}
</style>
